<div class="open-slots-header">
    <h2 mat-dialog-title>Open slots</h2>
    <div class="range">
        <button mat-icon-button (click)="previous()" matTooltip="Previous days" [disabled]="loading">
            <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="range-label">{{ rangeLabel }}</span>
        <button mat-icon-button (click)="next()" matTooltip="Next days" [disabled]="loading">
            <mat-icon>chevron_right</mat-icon>
        </button>
    </div>
    <button mat-icon-button mat-dialog-close matTooltip="Close">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="open-slots-content">
    <div class="state-message" *ngIf="loading">
        <mat-spinner diameter="32"></mat-spinner>
    </div>
    <p class="state-message" *ngIf="failed">The schedule could not be loaded. Close this and try again.</p>
    <p class="state-message" *ngIf="!loading && !failed && !days.length">
        No working days are set up in the schedule settings.
    </p>

    <div class="slot-grid" *ngIf="!loading && !failed && days.length"
        [style.grid-template-columns]="'var(--slot-time-width) repeat(' + days.length + ', minmax(var(--slot-min-width), 1fr))'">
        <div class="corner"></div>
        <div class="day-heading" *ngFor="let day of days; trackBy: trackByKey">
            <span class="weekday">{{ day.date | date: 'EEE' }}</span>
            <span class="date">{{ day.date | date: 'd MMM' }}</span>
        </div>

        <ng-container *ngFor="let time of times; let row = index">
            <div class="time">{{ time }}</div>
            <ng-container *ngFor="let day of days; trackBy: trackByKey">
                <div *ngIf="day.cells[row] as cell" class="slot" [ngClass]="cell.state"
                    [class.partly]="cell.state === 'free' && cell.taken > 0" [class.busy]="cell.busy"
                    [matTooltip]="cellTooltip(cell)" matTooltipClass="icd-tooltip"
                    [matTooltipDisabled]="!cell.items.length">
                    <ng-container *ngFor="let item of visibleItems(cell)">
                        <button *ngIf="item.patientId; else plainItem" type="button" class="item booking"
                            [style.border-left-color]="item.color" (click)="openPatient(item, $event)"
                            [attr.aria-label]="'Open ' + item.title">
                            <span class="item-title">{{ item.title }}</span>
                            <span class="item-detail" *ngIf="item.detail">{{ item.detail }}</span>
                        </button>
                        <ng-template #plainItem>
                            <span class="item" [class.event]="item.kind === 'event'" [class.busy-event]="item.busy"
                                [style.border-left-color]="item.color">
                                <span class="item-title">{{ item.title || 'Booked' }}</span>
                                <span class="item-detail" *ngIf="item.detail">{{ item.detail }}</span>
                            </span>
                        </ng-template>
                    </ng-container>
                    <span class="more" *ngIf="hiddenCount(cell)">+{{ hiddenCount(cell) }} more</span>
                    <button *ngIf="cell.state === 'free'; else stateLabel" type="button" class="state book"
                        (click)="choose(day, cell)"
                        [attr.aria-label]="'Book ' + (day.date | date: 'EEE d MMM') + ' ' + time">{{ label(cell) }}</button>
                    <ng-template #stateLabel>
                        <span class="state">{{ cell.state === 'past' && !cell.busy ? '–' : label(cell) }}</span>
                    </ng-template>
                </div>
            </ng-container>
        </ng-container>
    </div>
</mat-dialog-content>

<div class="legend" *ngIf="days.length">
    <span><i class="swatch free"></i>Free: click to book</span>
    <span><i class="swatch free partly"></i>Partly booked</span>
    <span><i class="swatch full"></i>Full</span>
    <span><i class="swatch busy"></i>Busy event</span>
    <span><i class="swatch past"></i>Past</span>
</div>
